import moment from 'moment';
import {
  SET_VM_OPTIONS,
  SET_FROM_DATE,
  SET_TO_DATE,
  SET_VMID,
  SET_SUBMIT_LOADING
} from './constants';

const initialState = {
  vmList: [],
  from: moment().subtract(7, 'd'),
  to: moment(),
  vmId: 0,
  loading: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_VM_OPTIONS:
      return {
        ...state,
        vmList: action.vmOptions
      };

    case SET_FROM_DATE:
      return {
        ...state,
        from: action.fromDate
      };

    case SET_TO_DATE:
      return {
        ...state,
        to: action.toDate
      };

    case SET_VMID:
      return {
        ...state,
        vmId: action.vmId
      };
    case SET_SUBMIT_LOADING:
      return {
        ...state,
        submitLoading: action.submitLoading
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Modules/DownloadCSV/reducer.js